/* @flow */

import * as React from 'react';
import { plural } from 'pluralize';

import ChallengeInfoTab from 'app/components/challenge/ChallengeInfoTab';
import BackButton from '../commons/BackButton';
import NavBar from '../commons/NavBar';
import { LEADERBOARD, PLAYERBOARD } from '../../constants/liveChallengeTabTypes';
import LightTabSet from '../commons/LightTabSet';
import MenuWrapper from '../commons/MenuWrapper';

type Props = {
  activeNavItem?: ChallengeNavItem,
  isOpen?: boolean,
  isRacing?: boolean,
  lineUpSize?: number,
  racingType?: string,
  onSelect: ChallengeNavItem => void,
  requiredSelections?: number,
  showLineupBuilder?: boolean,
  onBack?: () => void
};

const defaultProps = {
  activeNavItem: 'overview',
  racingType: undefined,
  isOpen: false,
  isRacing: false,
  onBack: undefined
};

function ChallengeNavBarMobile({
  activeNavItem,
  isOpen,
  isRacing,
  lineUpSize,
  onSelect,
  racingType,
  requiredSelections,
  showLineupBuilder,
  onBack
}: Props) {
  return (
    <NavBar>
      {onBack && (
        <BackButton
          onClick={onBack}
          innerStyle={{
            padding: '2px 10px'
          }}
        />
      )}
      <MenuWrapper component={LightTabSet} value={activeNavItem}>
        <ChallengeInfoTab id="overview" onSelect={onSelect}>
          Overview
        </ChallengeInfoTab>
        {isOpen && showLineupBuilder && (
          <ChallengeInfoTab id="players" onSelect={onSelect}>
            {isRacing && racingType ? plural(racingType) : 'Players'}
          </ChallengeInfoTab>
        )}
        {!isOpen && (
          <ChallengeInfoTab id={LEADERBOARD} onSelect={onSelect}>
            Leaderboard
          </ChallengeInfoTab>
        )}
        {!isOpen && (
          <ChallengeInfoTab id={PLAYERBOARD} onSelect={onSelect}>
            {isRacing ? 'Raceboard' : 'Playerboard'}
          </ChallengeInfoTab>
        )}
        {isOpen && showLineupBuilder && (
          <ChallengeInfoTab id="lineup" onSelect={onSelect}>
            {lineUpSize === requiredSelections
              ? 'Review team'
              : `Lineup (${lineUpSize}/${requiredSelections})`}
          </ChallengeInfoTab>
        )}
      </MenuWrapper>
    </NavBar>
  );
}

ChallengeNavBarMobile.defaultProps = defaultProps;

export default ChallengeNavBarMobile;
